module.exports = __webpack_public_path__ + "static/media/realtors-icon-18.4e6c00a3.svg";